import { Col } from '@repo/ui/components'
import type { WalletProjectCardsProps } from './wallet.types'
import { Fragment } from 'react'
import { WalletProjectCardItem } from './wallet-project.card-item'
import { WalletProjectsEmptyState } from './wallet-projects.empty-state'
import { UserProject } from '@repo/services'

export const WalletProjectCards = ({
  projects,
  userProjects,
  isLoading,
}: WalletProjectCardsProps) => {
  return (
    <Col>
      {userProjects.map((userProject) => {
        const project = projects.find(
          (project) => project.token === userProject.currency,
        ) as UserProject
        if (!project) return null
        return (
          <Fragment key={userProject.currency}>
            <WalletProjectCardItem
              project={project}
              userProject={userProject}
            />
          </Fragment>
        )
      })}
      {userProjects.length === 0 && !isLoading && (
        <WalletProjectsEmptyState isLoading={isLoading} />
      )}
    </Col>
  )
}
